export const toggleMenu = (force?: boolean) => {
	$('.accountActions__menuContainer').toggleClass('-active', force);
};

export const getIsMenuVisible = () => {
	return $('.accountActions__menuContainer').hasClass('-active');
};

export function init($: JQueryStatic) {
	$('.accountActions__loginButton').on('click', () => void toggleMenu());

	$(document).on('click', function (e) {
		const isClickWithinMenu =
			$(e.target).closest('.accountActions').length == 0;
		const isMenuVisible = getIsMenuVisible();

		if (isClickWithinMenu && isMenuVisible) {
			toggleMenu(false);
		}
	});
}
